import React, { ReactElement, useEffect, useState } from "react";
import DeflectionAction from "./actions/deflection/Deflection";
import FeedbackAction from "./actions/feedback/Feedback";

import {
    Action, ActionInputBody,
    useActionUpdateMutation,
} from "../../__generated__/api";
import { LoadingIcon } from "../../components/loading/Loading";
import useRouting, { useParams } from "../../contexts/Routing";

export default function Actions(): ReactElement {
    const { Paths } = useRouting();
    const { token } = useParams(Paths.ACTION);

    const [action, setAction] = useState<Action>();
    const [error, setError] = useState<string | undefined>();

    const [getData] = useActionUpdateMutation({
        variables: {
            input: {
                path: window.location.pathname.split("/").skip(2),
                token,
            },
        },
    });

    useEffect(() => {
        (async () => {
            try {
                const { data, errors } = await getData();
                if (errors) {
                    setError(errors[0].message);
                } else if (data?.actionUpdate) {
                    setAction(data?.actionUpdate);
                }
            } catch (err) {
                setError((err as Error).message);
            }
        })();
    }, []);

    const storeValue = async (value: ActionInputBody) => {
        const { data } = await getData({
            variables: {
                input: {
                    path: window.location.pathname.split("/").skip(2),
                    token,
                    value,
                },
            },
        });
        if (data?.actionUpdate) {
            setAction(data?.actionUpdate);
        }
    };

    let element: ReactElement;
    if (action?.feedback) {
        element = (
            <FeedbackAction
                action={action.feedback}
                onChange={feedback => storeValue({ feedback })}
            />
        );
    } else if (action?.deflection) {
        element = <DeflectionAction action={action.deflection} />;
    } else {
        element = <LoadingIcon className="mx-auto" />;
    }

    return (
        <div className="full-page">
            <div className="centered-container centered-container-lg pt-5 align-items-start">
                {error ? <div className="text-center w-100">{error}</div> : element}
            </div>

        </div>
    );
}
